import { PUBLIC_FEATURE_MATRIX, PUBLIC_PLANS } from "@/config/publicPlans";
import {
  isPaidCompareRow,
  PlanCompareCell,
} from "@/features/public/components/PlanCompareCell";
import { PublicPageShell } from "@/features/public/layout/PublicPageShell";

export function PublicPricingPage() {
  return (
    <PublicPageShell
      eyebrow="Free to start"
      title="Plans for exporting Stripe PDFs"
      lead={
        <>
          Most features are <strong className="pub-lead-free">free</strong>. Only
          Bulk Export PDFs is $10/mo.
        </>
      }
    >
      <div className="pub-plan-grid">
        {PUBLIC_PLANS.map((plan) => (
          <div
            key={plan.id}
            className={`pub-plan-card${plan.featured ? " pub-plan-card--featured" : " pub-plan-card--free"}`}
          >
            <p className="pub-plan-name">
              {plan.name}
              {plan.paid ? (
                <span className="ml-2 rounded-full bg-[var(--accent-light)] px-2 py-0.5 text-[0.65rem] font-bold uppercase tracking-wide text-[var(--accent)]">
                  Recommended
                </span>
              ) : (
                <span className="pub-free-badge">Always free</span>
              )}
            </p>
            {plan.paid ? (
              <>
                <p className="pub-plan-price">
                  {plan.launchPrice}
                  <span className="pub-plan-per">/mo</span>
                </p>
                <p className="pub-plan-promo">Billed monthly. Cancel anytime in Stripe.</p>
              </>
            ) : (
              <>
                <p className="pub-plan-price pub-plan-price--free">{plan.launchPrice}</p>
                <p className="pub-plan-promo">
                  Downloads, receipts, credit notes, and history. Only Bulk Export is
                  Pro.
                </p>
              </>
            )}
          </div>
        ))}
      </div>

      <h2 className="mb-2 mt-3 text-[0.9375rem] font-semibold">
        What&apos;s free vs Pro
      </h2>
      <div className="pub-compare-wrap">
        <table className="pub-compare">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {PUBLIC_FEATURE_MATRIX.map((row) => (
              <tr
                key={row.feature}
                className={isPaidCompareRow(row.pricing) ? "pub-compare-paid-row" : undefined}
              >
                <td>{row.feature}</td>
                <td>
                  <PlanCompareCell value={row.pricing} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pub-callout pub-callout-ok mt-3">
        <strong>Free on install.</strong> Browse, download PDFs, receipts, credit
        notes, pay links, and export history — no card required. Pro is only for Bulk
        Export.
      </div>

      <div className="pub-callout pub-callout-muted mt-3">
        <strong>How to subscribe</strong>
        <br />
        Install InvoiceVault → open from Stripe Dashboard → sidebar <strong>Plans</strong>.
        Pro payment opens in a new Stripe tab.
      </div>
    </PublicPageShell>
  );
}
